<template>
  <div class="page">
    <navigation class="nav">活动规则</navigation>
    <div class="container">
      <div class="content">
        <div class="section">
          <div class="title">活动时间：{{ new Date() | formateDate('YYYY年MM月DD日') }}</div>
        </div>
        <div class="section">
          <div class="title">活动对象</div>
          <div class="desc">天美贷平台指定优质用户</div>
        </div>
        <div class="section">
          <div class="title">活动方式</div>
          <div class="desc">1、 活动期间，前100名用户锁定预约提现，锁定名额成功后规定时间内前往我要提现页面发起提现申请，可享专属提现资金</div>
          <div class="desc">2、专属资金先到先得，用完为止。专属资金比普通资金放款通过率提升2倍</div>
        </div>
        <div class="section">
          <div class="title">领取使用方式</div>
          <div class="desc">活动期间，通过首页活动入口进入活动详情页，参与专属提现名额锁定，并前往我要提现页面进行使用，指定时间内平台将自动为您分配专属资金</div>
        </div>
      </div>
      <div class="footer">活动所有解释权归天美贷所有</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActTwoRules',
  mounted () {
    // todo: 活动时间取值？
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background-color: #FFF2DD;
  width: 100%;
  min-height: 100vh;
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 40px;
    .content {
      width: 670px;
      height: 1240px;
      border-radius: 30px;
      background-color: white;
      padding: 60px 30px;
      .section {
        margin-bottom: 60px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #333333;
          line-height: 45px;
        }
        .desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          line-height: 37px;
        }
      }
    }
    .footer {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #A5451E;
      line-height: 33px;
      margin-top: 50px;
    }
  }
}
</style>